export default __webpack_public_path__ + "static/media/wallet-link.9fa41556.svg";